export const PAYMENT_SUCCESSFUL_PARAM = 'payment-successful';
export const PAYMENT_SUBSCRIPTION_CANCELED_PARAM = 'payment-subscription-canceled';
export const PAYMENT_CREDITS_CANCELED_PARAM = 'payment-credits-canceled';
export const PRICE_ID_PARAM = 'price_id';
export const TAB_PARAM_NAME = 'tab';
export const TAB_PARAM_LIP_SYNC_VALUE = 'lip_sync';

export const LANDING_FLOW_KIND_PARAM = 'kind';
export const LANDING_MEDIA_ID_PARAM = 'media_id';
export const LANDING_MEDIA_LINK_PARAM = 'media_link';
export const LANDING_TARGET_LANG_PARAM = 'target_lang';

export const AUTH_TYPE_PARAM = 'type';
export const AUTH_TYPE_SIGNUP = 'signup';
export const AUTH_TYPE_SIGNIN = 'signin';

export const TRIAL_VIEW_PARAM = 'view';
export const TRIAL_VIEW_EDITOR = 'editor';
